var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import traverse from 'traverse';
import hash from 'object-hash';

var addMissingIds = function addMissingIds(presentationVersion) {
  return function (jsonLd) {
    traverse(jsonLd).forEach(function (obj) {
      // Presentation 2 has 3 optional.
      if (presentationVersion >= 2.0 && presentationVersion <= 2.1 && (obj['@type'] === 'oa:Annotation' || obj['@type'] === 'sc:Sequence' || obj['@type'] === 'oa:Choice') && !obj['@id']) {
        this.update(_extends({}, obj, { '@id': 'https://' + hash(obj) }));
      }
      // Presentation 3 has only one optional.
      // But then again, some common missing ids...
      if (presentationVersion === 3.0 && (obj.type === 'AnnotationPage' || obj.type === 'Annotation' || obj.type === 'Application' || obj.type === 'Dataset' || obj.type === 'Image' || obj.type === 'Sound' || obj.type === 'Text' || obj.type === 'Video' || obj.type === 'TextualBody' || obj.profile) && !obj.id) {
        this.update(_extends({}, obj, { id: 'https://' + hash(obj) }));
      }
    });
    return jsonLd;
  };
};

export default addMissingIds;